export default __webpack_public_path__ + "static/circle-shape1-84499f1a9f5baf6107753940a219d149.png";